export const messages = {
  en: {
    ownerDining: {
      search: {
        title: 'Search Conditions',
        startDate: 'Select start date',
        endDate: 'Select end date',
        nameLike: 'Enter owner name',
        link: 'Enter owner phone'
      },
      list: {
        title: 'Owner Dining Records'
      },
      table: {
        startDate: 'Start Date',
        endDate: 'End Date',
        name: 'Owner Name',
        link: 'Phone',
        goodsName: 'Goods',
        frequency: 'Frequency'
      },
      fetchError: 'Failed to fetch data',
      exportSuccess: 'Export successful',
      exportError: 'Export failed',
      page: {
        subtitle: 'Review owner dining reservations and usage frequency',
        empty: 'No dining record data',
        loadFailed: 'Failed to load dining record list'
      }
    }
  },
  zh: {
    ownerDining: {
      search: {
        title: '查询条件',
        startDate: '请选择开始时间',
        endDate: '请选择结束时间',
        nameLike: '请输入业主名称',
        link: '请选择业主手机号'
      },
      list: {
        title: '业主就餐'
      },
      table: {
        startDate: '开始时间',
        endDate: '结束时间',
        name: '业主名称',
        link: '手机号',
        goodsName: '商品',
        frequency: '就餐次数'
      },
      fetchError: '获取数据失败',
      exportSuccess: '导出成功',
      exportError: '导出失败',
      page: {
        subtitle: '查看业主订餐记录与就餐次数统计',
        empty: '暂无订餐记录数据',
        loadFailed: '获取订餐记录列表失败'
      }
    }
  }
}